<template>
  <div style="overflow: auto">
  </div>
</template>

<script>

export default {
  created () {
    //const data = this.$store.state.auth.userInfo
  }
}
</script>
